// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__WXlFO","requiredAsterisk":"Info_requiredAsterisk__2KYXP"};